import { useQuery } from '@tanstack/react-query';

import { fetchSharedComponents } from '../services/api/components';

import type { ComponentResponse } from '../types';

export const useSharedComponents = () => {
  return useQuery({
    queryKey: ['components', 'shared'],
    queryFn: fetchSharedComponents,
    initialData: [] as ComponentResponse[],
  });
};
